import { render } from "./Show.vue?vue&type=template&id=26478df2&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=26478df2&scoped=true&lang=scss"
import "./Show.vue?vue&type=style&index=1&id=26478df2&lang=scss"
script.render = render
script.__scopeId = "data-v-26478df2"

export default script